/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule } from '@angular/core';

import { ElSharedModule } from '../shared/shared.module';
import { ElProgressBarComponent } from './progress-bar.component';

@NgModule({
  imports: [
    ElSharedModule,
  ],
  declarations: [ElProgressBarComponent],
  exports: [ElProgressBarComponent],
})
export class ElProgressBarModule { }
